// Client-side mirror of backend/utils/price.js getShippingDominantRate.
//
// Dominant-rate rule for Swiss shipping VAT: the shipping fee
// is charged at the VAT rate of the MAJORITY of the shipped goods, measured by
// their gross (VAT-inclusive) monetary value.
// An exact 50/50 split by value resolves to the Standard Rate (8.1%).
// Entries are { net (net line amount), vat_rate } with vat_rate > 5
// classed as Standard; anything else (2.6% / 3.8%) as Reduced.
export function getShippingDominantRate(entries) {
  let reducedGross = 0;
  let standardGross = 0;
  (entries || []).forEach((e) => {
    const rate = Number(e?.vat_rate) || 0;
    const grossValue = (Number(e?.net) || 0) * (1 + rate / 100);
    if (rate > 5) standardGross += grossValue;
    else reducedGross += grossValue;
  });
  return standardGross >= reducedGross ? 8.1 : 2.6;
}